import { normalizeError } from "./normalize"

export function shouldReportError(error: unknown): boolean {
  return normalizeError(error).reportable
}

export function errorReportingContext(error: unknown, context?: Record<string, unknown>) {
  const normalized = normalizeError(error)
  return {
    ...context,
    errorCode: normalized.code,
    requestId: normalized.requestId,
    userMessage: normalized.userMessage,
  }
}
